import React from 'react'
import { Body, ComingSoon } from '../Resource'

export default function Logistics() {
    return (
        <Body>
            <ComingSoon title="Logistics" />
        </Body>
    )
}
